import * as React from 'react';
import { ComboboxWithSearchFormControl } from 'sos-common/js/components/FormControls/ComboboxWithSearchFormControl';
import { TextInput } from 'sos-common/js/components/FormControls/TextInput';
import { RadioButtonGroup } from 'sos-common/js/components/FormControls/RadioButtonGroup';
import { RadioButton } from 'sos-common/js/components/FormControls/RadioButton';
import { SelectBox, SelectBoxOption } from 'sos-common/js/components/FormControls/SelectBox';
import { MultiSelectComboboxFormControl } from 'sos-common/js/components/FormControls/MultiSelectComboboxFormControl';
import { FormField } from 'sos-common/js/commonTypes/formField.types';
import { SectionClass, SectionProps, SectionState, FieldName, TypeOfAnsokan } from '../PublicForm.types';
import { MAX_LENGTH_NUM } from '../publicform.validation.service';
import { ComboboxItem, MultiSelectItem } from 'sos-common/js/commonTypes/multiSelect.types';
import { Yrke } from '../../AnsokanForms/LegAnsokanForm.types';

export interface ISpecialistkompetensDetailsSectionProps extends SectionProps {
  Translate: (key: string, defaultValue?: string) => string;
  secondSpecialist?: boolean;
  textBoxId: string;
  hasWorked3YearsInEUEES: boolean;
  typeOfAnsokan: TypeOfAnsokan;
  countryList: string[];
  activeYrke: Yrke;
}

export interface ISpecialistkompetensDetailsSectionState extends SectionState {
  showOtherCountry: boolean;
  showOtherSpecialistbevisTypeField: boolean;
  otherCountries: string[];
}

export default class SpecialistkompetensDetailsSection extends SectionClass<
  ISpecialistkompetensDetailsSectionProps,
  ISpecialistkompetensDetailsSectionState
> {
  private typAvSpecialist: FieldName;
  private otherSpecialistbevisType: FieldName;
  private datumSpecialist: FieldName;
  private specialLangd: FieldName;
  private specialistUtbildningsland: FieldName;
  private harSpecialistIAnnatLand: FieldName;
  private angeSpecialistLand: FieldName;
  private angeSpecialistLandController: FieldName;
  private _educatedOutsideEuEesTextSwe = 'Utanför EU/EES';
  private _educatedOutsideEuEesTextEn = 'Outside EU/EES';
  private _mandatoryString: string;
  constructor(props: ISpecialistkompetensDetailsSectionProps) {
    super(props);
    this._mandatoryString = ' ' + props.Translate('mandatory');
    if (!props.secondSpecialist) {
      this.typAvSpecialist = FieldName.TypAvSpecialist;
      this.datumSpecialist = FieldName.DatumSpecialist;
      this.specialLangd = FieldName.SpecialLangd;
      this.specialistUtbildningsland = FieldName.SpecialistUtbildningsland;
      this.harSpecialistIAnnatLand = FieldName.HarSpecialistIAnnatLand;
      this.angeSpecialistLand = FieldName.AngeSpecialistLand;
      this.angeSpecialistLandController = FieldName.AngeSpecialistLandController;
      this.otherSpecialistbevisType = FieldName.AnnanSpecialistbevistyp;
    } else {
      this.typAvSpecialist = FieldName.TypAvSpecialist_2;
      this.datumSpecialist = FieldName.DatumSpecialist_2;
      this.specialLangd = FieldName.SpecialLangd_2;
      this.specialistUtbildningsland = FieldName.SpecialistUtbildningsland_2;
      this.harSpecialistIAnnatLand = FieldName.HarSpecialistIAnnatLand_2;
      this.angeSpecialistLand = FieldName.AngeSpecialistLand_2;
      this.angeSpecialistLandController = FieldName.AngeSpecialistLandController_2;
      this.otherSpecialistbevisType = FieldName.AnnanSpecialistbevistyp_2;
    }

    const requiredFields =
      this.props.hasWorked3YearsInEUEES && this.props.typeOfAnsokan === TypeOfAnsokan.Specialistkompetens
        ? [this.typAvSpecialist, this.harSpecialistIAnnatLand]
        : [this.typAvSpecialist, this.specialistUtbildningsland, this.harSpecialistIAnnatLand];

    this.state = {
      showOtherCountry: false,
      showOtherSpecialistbevisTypeField: false,
      errors: this.getInitialErrorMap(requiredFields),
      otherCountries: [],
    };
  }

  get countrySelectBoxOption(): SelectBoxOption[] {
    return this.props.countryList.map((country) => {
      return { key: country, text: country };
    });
  }

  onChangeOtherCountry = (field: FormField<string>) => {
    const errors = new Map(this.state.errors);
    const { Translate } = this.props;

    const showOtherCountry = field.value === 'Ja';
    if (showOtherCountry) {
      errors.set(this.angeSpecialistLandController, { showMessage: false, errorMessage: Translate('error_mandatory') });
    } else {
      errors.delete(this.angeSpecialistLandController);
    }

    this.setState({ showOtherCountry, errors }, () => {
      this.onChangeField(field);
      if (showOtherCountry) {
        const specialistLandElem = document.getElementById(this.props.textBoxId);
        specialistLandElem?.focus();
      }
    });
  };

  onChangeSpecialistBevisTypes = (field: FormField<string>) => {
    const showOtherSpecialistbevisTypeField = field.value === 'Annat' || field.value === 'Other';

    this.setState({ showOtherSpecialistbevisTypeField }, () => {
      this.onChangeField(field);
    });
  };

  SelectOtherCountry = (MultiSelectItem: MultiSelectItem[]) => {
    const data = {
      isRequired: true,
      value: MultiSelectItem.map((x) => x.value),
      isTouched: true,
      selectedText: this.angeSpecialistLandController,
      fieldName: this.angeSpecialistLandController,
    };

    this.setState({ otherCountries: MultiSelectItem.map((x) => x.value) }, () => this.onChangeField(data));
    this.onChangeField(data);
  };

  getSpecialistbevisTypes = (): ComboboxItem[] => {
    var isTandLakare = this.props.activeYrke == Yrke.Tandlakare;
    var translateList = isTandLakare ? 'specialistbevisTypListaTandlakare' : 'specialistbevisTypLista';
    const list = this.props.Translate(translateList);

    return list.split(',').map((item) => {
      return { key: item, value: item } as ComboboxItem;
    });
  };

  public render() {
    const { Translate, formLanguage } = this.props;
    const { showOtherCountry } = this.state;

    return (
      <div>
        <div className="row m-b-2">
          <div className={`col-sm-6`}>
            <ComboboxWithSearchFormControl
              label={Translate(this.typAvSpecialist) + this._mandatoryString}
              items={this.getSpecialistbevisTypes()}
              errorMessage={this.getErrorMessage(this.typAvSpecialist)}
              id={this.typAvSpecialist}
              onChange={this.onChangeSpecialistBevisTypes}
              isRequired={true}
              fieldName={this.typAvSpecialist}
              isTouched={true}
              placeholder={Translate('specialistbevistypPlaceholder')}
            />
          </div>
        </div>
        {this.state.showOtherSpecialistbevisTypeField && (
          <div className="row m-b-2">
            <div className={`col-sm-6`}>
              <TextInput
                onChange={this.onChangeField}
                errorMessage={this.getErrorMessage(this.otherSpecialistbevisType)}
                label={Translate(this.otherSpecialistbevisType) + this._mandatoryString}
                isRequired={true}
                fieldName={this.otherSpecialistbevisType}
                maxLength={MAX_LENGTH_NUM}
                showMaxLengthMessage={true}
                maxLengthMessageLanguage={formLanguage}
              />
            </div>
          </div>
        )}

        <div className="row m-b-2">
          {this.props.hasWorked3YearsInEUEES && this.props.typeOfAnsokan === TypeOfAnsokan.Specialistkompetens ? (
            <input
              type="hidden"
              name={this.specialistUtbildningsland}
              value={
                this.props.formLanguage === 'sv' ? this._educatedOutsideEuEesTextSwe : this._educatedOutsideEuEesTextEn
              }
            />
          ) : (
            <div className={`col-sm-6`}>
              <SelectBox
                onChange={this.onChangeField}
                label={Translate(this.specialistUtbildningsland) + this._mandatoryString}
                defaultOptionText={Translate('valjutbildningsland')}
                fieldName={this.specialistUtbildningsland}
                options={
                  this.props.typeOfAnsokan === TypeOfAnsokan.Specialistkompetens
                    ? this.countrySelectBoxOption.filter(
                        (x) => x.key !== this._educatedOutsideEuEesTextSwe && x.key !== this._educatedOutsideEuEesTextEn
                      )
                    : this.countrySelectBoxOption
                }
                errorMessage={this.getErrorMessage(this.specialistUtbildningsland)}
                isRequired={true}
              />
            </div>
          )}
        </div>

        <div className="like-a-label">{Translate(this.harSpecialistIAnnatLand) + this._mandatoryString}</div>
        <RadioButtonGroup
          isRequired={true}
          onChange={this.onChangeOtherCountry}
          fieldName={this.harSpecialistIAnnatLand}
          errorMessage={this.getErrorMessage(this.harSpecialistIAnnatLand)}>
          <RadioButton value="Ja" label={Translate('ja')} />
          <RadioButton value="Nej" label={Translate('nej')} />
        </RadioButtonGroup>

        {showOtherCountry && (
          <div className="row m-b-4">
            <div className="col-sm-6">
              <MultiSelectComboboxFormControl
                items={this.props.countryList.map((x) => {
                  return { key: x, value: x, isSelectedByDefault: false } as MultiSelectItem;
                })}
                enableShowAllOption={false}
                textBoxLabelText={Translate('valjlandLander')}
                showRemoveSelectionsButton={false}
                onSelectedItemsChange={this.SelectOtherCountry}
                fieldName={this.angeSpecialistLandController}
                id={this.angeSpecialistLandController}
                isRequired={true}
                errorMessage={this.getErrorMessage(this.angeSpecialistLandController)}
                showErrorMessageWithoutTouched={this.props.submitButtonIsClicked}
              />
              <input
                type="hidden"
                name={this.angeSpecialistLand}
                value={this.state.otherCountries ? this.state.otherCountries.join(',') : ''}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}
